import { FAVORITE_RESOURCES } from '@/Ship/Configs/FavoriteResourcesConfig'

import { FavoriteCommentButton } from './FavoriteCommentButton'
import { FavoriteToggle } from './FavoriteToggle'

import type { IFormButtonHandlerParams } from '@/Core/Features/UI/CrudResource'

/**
 * Ставить зірочку «в обране» в шапку картки — обробник `onButtons` ядрової
 * CRUD-фічі, підключений у `CrudResourceConfig`.
 *
 * Зірочка перша зліва: це не дія над документом, а позначка для себе, тож
 * основні кнопки («Редагувати», переходи статусу) лишаються на звичних місцях.
 * Видно її лише в перегляді: у новому записі позначати ще нічого, а у формі
 * назва може бути незбереженою.
 *
 * Поруч — «Додати в обране з коментарем» (`SPEC-014` §4.3): видна, лише поки
 * запис не позначено, — це вирішує сама кнопка.
 */
export const FavoriteButton = ({ buttons, crudContext }: IFormButtonHandlerParams): void => {
    const resourceKey: unknown = crudContext?.resource?.key

    if (typeof resourceKey !== 'string' || !FAVORITE_RESOURCES.includes(resourceKey)) return

    const inView = (): boolean => {
        const formContext = crudContext.formContext

        return !formContext?.isEditable && typeof formContext?.values?.uuid === 'string'
    }

    buttons['favorite'] = {
        sort: -100,
        priority: 'button',
        depFn: inView,
        children: <FavoriteToggle key="favorite" resourceKey={resourceKey} crudContext={crudContext} />,
    }

    buttons['favoriteComment'] = {
        sort: -99,
        priority: 'button',
        depFn: inView,
        children: <FavoriteCommentButton key="favoriteComment" resourceKey={resourceKey} crudContext={crudContext} />,
    }
}
